import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { SkipLink } from './SkipLink';
import { ScrollToTop } from './ScrollToTop';
import { QuickQA } from './QuickQA';

export function Layout() {
  return (
    <div className="app">
      <SkipLink />
      <Header />
      <ScrollToTop />
      <main id="main-content" className="main" role="main">
        <Outlet />
      </main>
      <Footer />
      <QuickQA />
    </div>
  );
}
